module.exports = __webpack_public_path__ + "img/goods16_1.ee6cc63d.jpg";